import { render, staticRenderFns } from "./ModalFreePicks.vue?vue&type=template&id=90164c9a"
import script from "./ModalFreePicks.vue?vue&type=script&lang=js"
export * from "./ModalFreePicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports